import { Box, Heading, Image } from '@chakra-ui/react';
import React from 'react';
import Cecilia from '../../assets/img/at_cecilia.jpeg';

const Hero = () => (
    <Box
        w="100vw"
        p="2.5"
        m="auto"
        maxW="1150px"
    >
        <Box
            pos="relative"
            h={{ base: "44vh", md: "60vh", lg: "80vh" }}
            w="100%"
        >
            <Box
                bg="secondary.1"
                w={{ base: "90%", lg: "50%" }}
                h="50%" borderRadius={10}
                pos="absolute"
                left={{ base: "5%", lg: "40%" }}
            ></Box>
            <Box
                bg="primary.2"
                borderRadius={10}
                pos="absolute" bottom="10%" right={3}
                h="70%"
                w="70%"
                p={{ base: "2", lg: "4" }}
                textAlign="right"
            >
                <Heading
                    as="h2"
                    fontSize={{ base: "36", lg: "128" }}
                    color="gray.400"
                    fontWeight="normal"
                >
                    UX
                </Heading>
            </Box>
            <Box
                pos="absolute"
                p={{ base: "2", lg: "4" }}
                borderRadius={10}
                bottom={3}
                right={0}
                minW="30%"
                h="50%"
                bg="gray.400"
                display="flex"
                justifyContent="flex-end"
                alignItems="end"
            >
                <Heading
                    as="h2"
                    fontSize={{ base: "20", lg: "65" }}
                    fontWeight="normal"
                    color="gray.700"
                    bottom="2.5"
                >
                    Frontend Developer
                </Heading>
            </Box>
            <Box
                bg="primary.1"
                borderRadius={10}
                h="70%"
                w="80%"
                pos="absolute" p={2.5} top="5%" left={0}
            >
                <Box>
                    <Heading
                        as="h1"
                        fontSize={{ base: "36", lg: "101" }}
                        fontWeight="normal"
                        color="white"
                    >
                        Cecilia Lagerwall
                    </Heading>
                </Box>
                <Box
                    borderRadius={10}
                    overflow="hidden"
                    mt={2}
                    ml={{ base: 0, lg: "10%" }}
                    maxW={{ base: "60%", lg: "40%" }}
                    maxH={{ base: "270px", lg: "520px" }}
                >
                    <Image src={Cecilia} alt="Image of Cecilia Lagerwall" />
                </Box>
            </Box>
        </Box>
    </Box>
);

export default Hero;